export default "//cdn.scentbird.com/assets/frontbird-site/images/andrey_1545ea.png";